__turbopack_context__.v({
  "bounce": "N294tG_bounce",
  "chipsContainer": "N294tG_chipsContainer",
  "elementDivider": "N294tG_elementDivider",
  "fadeIn": "N294tG_fadeIn",
  "mask": "N294tG_mask",
  "root": "N294tG_root",
  "search": "N294tG_search",
  "searchBtn": "N294tG_searchBtn",
  "searchFood": "N294tG_searchFood",
  "searchFoodOverlay": "N294tG_searchFoodOverlay",
  "suggestions": "N294tG_suggestions",
});
